import React, { FC, useCallback, useMemo } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import AccountAutocomplete from '../AccountAutocomplete';
import { Account, Employee, Terminal } from '~/types';
import { OatConsentData } from './OatConsentData';

interface RecipientAccountProps {
  className?: string;
  setMainState: React.Dispatch<React.SetStateAction<OatConsentData>>;
  mainState: OatConsentData;

  loading?: boolean;
  accounts?: Account[];
  terminals?: Terminal[];
  employees?: Employee[];
}

const RecipientAccount: FC<RecipientAccountProps> = (props) => {
  const { className, setMainState, mainState, loading, accounts, terminals, employees } = props;

  const [t] = useTranslation('oat');

  const senderAccountId = mainState.senderAccount?.id;

  const accountFilter = useMemo<any>(() => {
    return (account: Account) => account.id !== senderAccountId;
  }, [senderAccountId]);

  const onChange = useCallback(
    (recipientAccount: Account | undefined) =>
      setMainState((prev) => ({ ...prev, recipientAccount, recipientAccountReset: false })),
    [setMainState]
  );

  return (
    <div className={`${className} RecipientAccount`}>
      <Typography.Title level={4}>{t('To account')}</Typography.Title>
      <AccountAutocomplete
        onChange={onChange}
        accountId={mainState.recipientAccount?.id}
        hiddenAccount={!mainState.senderAccount?.id}
        disabled={!mainState.senderAccount?.id}
        reset={mainState.recipientAccountReset}
        accountFilter={accountFilter}
        loading={loading}
        accounts={accounts}
        terminals={terminals}
        employees={employees}
      />
    </div>
  );
};

export default RecipientAccount;
